import axios from "axios"
// import { getStorage } from "@/storage"
import { Message } from "element-ui"

let init_host = ''
if (window.location.href.indexOf('.cn') != '-1') {
  init_host = 'http://api.cuntoubao.cn';
  window.localStorage.ctb_manage_host = init_host;
  window.localStorage.imgpath = 'http://img.cuntoubao.cn/';
} else {
  init_host = 'http://api.cuntoubao.test';
  window.localStorage.ctb_manage_host = init_host;
  window.localStorage.imgpath = 'http://testimg.cuntoubao.cn/';
}

const http = axios.create({
  baseURL: init_host,
  timeout: 60000
})

http.interceptors.request.use((req) => {
  if(req.data.type == 'upload'){
    req.data = req.data.formData;
  }
 
  req.data.token = window.localStorage.token || ''
  return req
})

http.interceptors.response.use((res) => {
  const { code, msg } = res.data
  if (code == 1) {
    return res.data
  } else {
    Message.error(msg);
    return Promise.reject(res)
  }
}, function (res) {
  Message.error("请求失败");
  return Promise.reject(res)
})

export default http
